"use strict";

($dt => {
	
	$dt.blocks['standard-expanding-items'] = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			
			const section = {
				faqs: [],
				multiple: false,
				container: null,

				Init: block => {
					section.container = block;
					section.multiple = section.container.getAttribute('data-allow-multiple-open') === 'true';

					const buttons = section.container.querySelectorAll('dl button');
					if (buttons) {
						buttons.forEach(button => {
							const faq = {
								id: null,
								button: null,
								answer: null,
								expanded: false,

								Init: button_elem => {
									faq.button = button_elem;
									faq.id = faq.button.getAttribute('aria-controls');
									faq.answer = document.querySelector('#' + faq.id);

									faq.button.addEventListener('click', e => {
										e.preventDefault();
										section.ExpandFAQ(faq);
									});
								}
							};

							faq.Init(button);
							section.faqs.push(faq);
						});
					}
				},

				ExpandFAQ: faq => {
					if (faq.expanded) {
						faq.button.classList.remove('expanded');
						faq.answer.classList.remove('expanded');
						faq.expanded = false;
					} else {
						if (!section.multiple) {
							// Close other questions
							section.faqs.forEach(faqHide => {
								faqHide.button.classList.remove('expanded');
								faqHide.answer.classList.remove('expanded');
								faqHide.expanded = false;
							});
						}

						faq.button.classList.add('expanded');
						faq.answer.classList.add('expanded');
						faq.expanded = true;
					}
				}
			};
			
			section.Init(container);
		}
		
	};
	
})(window.d3_wp_themejs);
